import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import Text from '@raydiant/raydial/components/Text';
import LiteDeviceImg from './lite-device.svg';
import Button from '@raydiant/raydial/components/Button';

interface PurchaseDeviceDialogProps {
  isOpen: boolean;
  onSubscribe: () => void;
  onClose: () => void;
}

const PurchaseDeviceDialog = ({
  isOpen,
  onSubscribe,
  onClose,
}: PurchaseDeviceDialogProps) => {
  return (
    <Modal isOpen={isOpen} className="overflow-auto">
      <Dialog className="grid relative" showCloseButton onClose={onClose}>
        <DialogHeader>
          <DialogHeading>Unlock all the power of Displai!</DialogHeading>
        </DialogHeader>
        <div className="flex flex-col items-center px-4">
          <img
            src={LiteDeviceImg}
            alt="free trial expired"
            className="w-[274px] aspect-[1.028] mb-8"
          />
          <Text className="text-center text-2xl md:text-3xl font-semibold">
            Looking to add another screen? Get another device license
          </Text>
          <Text className="mt-6 md:mt-10">
            Each screen requires a device license subscription to access the
            Displai CMS and keep the device running smoothly. You can get an
            annual subscription discount if you subscribe now!
          </Text>
        </div>
        <footer className="flex flex-wrap gap-6 pb-4 px-4 mt-8">
          <Button
            size="large"
            variant="primary"
            className="grow"
            onPress={onSubscribe}
          >
            Subscribe Now
          </Button>
        </footer>
      </Dialog>
    </Modal>
  );
};

export default PurchaseDeviceDialog;
